/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetZonesByRegionAdminResponse } from '../models/GetZonesByRegionAdminResponse';
import type { PostRegionZonesAdminRequest } from '../models/PostRegionZonesAdminRequest';
import type { PostRegionZonesAdminResponse } from '../models/PostRegionZonesAdminResponse';
import type { PutZoneActiveAdminRequest } from '../models/PutZoneActiveAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ZonesService {
    /**
     * **Required Policy:** `ManageRegionZones`
     * @returns PostRegionZonesAdminResponse OK
     * @throws ApiError
     */
    public static postZonesByRegionAdmin({
        requestBody,
    }: {
        requestBody?: PostRegionZonesAdminRequest,
    }): CancelablePromise<PostRegionZonesAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/zones',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRegionZones`
     * @returns GetZonesByRegionAdminResponse OK
     * @throws ApiError
     */
    public static getZonesByRegionAdmin({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<GetZonesByRegionAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/zones/regions/{regionId}',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRegionZones`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteZoneAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/zones/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageRegionZones`
     * @returns any OK
     * @throws ApiError
     */
    public static putZoneActiveAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutZoneActiveAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/zones/{id}/active',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
